export default __webpack_public_path__ + "static/media/logo.55297e47.png";